import {twMerge} from '@sdox/utils'

import {LazyImage} from '../LazyImage'
import {RichText} from '../RichText'

import type {LazyImageProps} from '../LazyImage'
import type {ReactNode} from 'react'

export interface KeyFactSmallMediaProps {
  imageProps: LazyImageProps
  hasDivider?: boolean
}

export interface KeyFactSmallProps {
  media: KeyFactSmallMediaProps
  callout?: string
  description?: string
  heading: string
  cta?: ReactNode
}

export const KeyFactSmall = (props: KeyFactSmallProps) => {
  const {
    callout,
    cta,
    description,
    heading,
    media,
  } = props

  const {className: imgClassName, ...imageProps} = media.imageProps

  return (
    <div>
      <LazyImage
        className={twMerge('aspect-[1/1] size-spacing-96 rounded-radius-md object-cover object-center', imgClassName)}
        {...imageProps}
      />
      <hr className={'mt-spacing-24 border-outline-secondary'} />
      <div className={'flex flex-col gap-spacing-8 pr-spacing-24 pt-spacing-20'}>
        {callout ? (
          <div className={'line-clamp-2 text-p1'}>
            {callout}
          </div>
        ) : null}
        <div className={'line-clamp-3 text-p1-emphasized'}>
          {heading}
        </div>
        {description ? (
          <RichText
            as={'div'}
            className={'max-w-text text-p1 text-glyph-default-secondary'}
            content={description}
            allowedTags={['a', 'br', 'span']}
          />
        ) : null}
        {cta ? (
          <span className={'mt-spacing-8'}>{cta}</span>
        ) : null}
      </div>
    </div>
  )
}
